<template lang="pug">
  div
    section.content-header
      h1 設定状況

      ol.breadcrumb
        li.active
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理

    section.content
      index-info

      .row
        .col-md-6
          .small-box.bg-aqua
            .inner
              h3
                | {{usercount}}
              p ユーザー数
            .icon
              i.fa.fa-user
            router-link(:to="{name: 'user'}" data-testid="link-user-list").small-box-footer
              | もっと見る
              i.fa.fa-arrow-circle-right

        .col-md-6
          .small-box.bg-green
            .inner
              h3
                | {{groupcount}}
              p 組織数
            .icon
              i.fa.fa-users
            router-link(:to="{name: 'group'}" data-testid="link-group-list").small-box-footer
              | もっと見る
              i.fa.fa-arrow-circle-right

      .row
        .col-lg-6.col-md-12
          .box.box-gray.bcard-admin-dashboard-box
            .box-header.with-border
              .box-title
                i.fa.fa-fw.fa-sliders
                | 基本設定
            .box-body

              h5 パスワードポリシー
              ul.nav.nav-pills.nav-stacked
                li
                  router-link(:to="{name: 'Passwordpolicy'}")
                    span.nav-item パスワード有効期限（日数）
                    span.pull-right {{pwdpolicy.pwdlimit ? pwdpolicy.pwdlimit + ' 日' : '有効期限を適用しない'}}
                li
                  router-link(:to="{name: 'Passwordpolicy'}")
                    span.nav-item ログイン再試行回数
                    span.pull-right {{pwdpolicy.login_failures_permitted ? pwdpolicy.login_failures_permitted + ' 回': '無制限'}}

              h5 添付ファイルサイズ設定
              ul.nav.nav-pills.nav-stacked
                li
                  router-link(:to="{name: 'AttachsizeSetting'}")
                    span.nav-item ファイルサイズの上限
                    span.pull-right {{attachsize.attachsize}}

              h5 ライセンス情報
              ul.nav.nav-pills.nav-stacked
                li
                  router-link(:to="{name: 'LicenseSetting'}")
                    span.nav-item 名刺契約枚数
                    span.pull-right {{license.formatted_bcard_count}} 枚 / {{license.formatted_contract_count}} 枚
                      |
                      |
                      span(:class="Number(license.formatted_bcard_usage) > 100 ? 'text-red text-bold': ''") ({{license.formatted_bcard_usage}} %)
                li
                  router-link(:to="{name: 'LicenseSetting'}")
                    span.nav-item 修正サービス契約
                    span.pull-right {{license.contract_input === '---' ? license.contract_input : (license.contract_input === app_flag.ON ? '契約あり' : '契約なし')}}
                li
                  router-link(:to="{name: 'LicenseSetting'}")
                    span.nav-item 同一人物判定バッチ開始日
                    span.pull-right {{license.formatted_judgement_date || app_lang.NO_SELECT}}

        .col-lg-6.col-md-12
          .box.box-gray.bcard-admin-dashboard-box
            .box-header.with-border
              .box-title
                i.fa.fa-fw.fa-sign-in
                | モバイルログイン設定
            .box-body
              ul.nav.nav-pills.nav-stacked
                li
                  router-link(:to="{name: 'MbLoginSetting'}")
                    span.nav-item 企業コード
                    span.pull-right(v-if="mblogin.mbcompanycodesave === app_flag.ON") 保存を許可する
                    span.pull-right(v-else-if="mblogin.mbcompanycodesave === app_flag.OFF") 保存を許可しない
                    span.pull-right(v-else) {{mblogin.mbcompanycodesave}}
                li
                  router-link(:to="{name: 'MbLoginSetting'}")
                    span.nav-item ログインID
                    span.pull-right(v-if="mblogin.mbloginidsave === app_flag.ON") 保存を許可する
                    span.pull-right(v-else-if="mblogin.mbloginidsave === app_flag.OFF") 保存を許可しない
                    span.pull-right(v-else) {{mblogin.mbloginidsave}}
                li
                  router-link(:to="{name: 'MbLoginSetting'}")
                    span.nav-item パスワード
                    span.pull-right(v-if="mblogin.mbloginpwdsave === app_flag.ON") 保存を許可する
                    span.pull-right(v-else-if="mblogin.mbloginpwdsave === app_flag.OFF") 保存を許可しない
                    span.pull-right(v-else) {{mblogin.mbloginpwdsave}}
                li
                  router-link(:to="{name: 'MbLoginSetting'}")
                    span.nav-item セッション情報の有効期間
                    span.pull-right {{session_hour}} 時間 {{session_min}} 分

</template>

<script>
import IndexInfo from './IndexInfo'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AdminRepository = RepositoryFactory.get('admin')

export default {
  name: 'Admin',
  components: { IndexInfo },
  data () {
    return {
      usercount: '---',
      groupcount: '---',
      pwdpolicy: {
        pwdlimit: '---',
        login_failures_permitted: '---'
      },
      attachsize: {
        attachsize: '---'
      },
      license: {
        formatted_contract_count: '---',
        contract_input: '---',
        formatted_judgement_date: '---'
      },
      mblogin: {
        mbloginidsave: '---',
        mbloginpwdsave: '---'
      },
      session_hour: '---',
      session_min: '---'
    }
  },
  created () {
    const vm = this

    // API実行
    AdminRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.usercount = data.usercount
        vm.groupcount = data.groupcount
        vm.pwdpolicy = data.pwdpolicy
        vm.attachsize = data.attachsize
        vm.license = data.license
        vm.mblogin = data.mblogin
        if (Number.isInteger(vm.mblogin.mbloginsidterm)) {
          vm.session_hour = Math.floor(vm.mblogin.mbloginsidterm / 60)
          vm.session_min = vm.mblogin.mbloginsidterm % 60
        }
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  }
}
</script>

<style lang="scss" scoped>
.bcard-admin-dashboard-box {
  .box-body > h5 {
    padding-top: 5px;
    padding-bottom: 10px;

    border-bottom: 1px solid #f4f4f4;
  }

  .nav-item:after {
    content: ' : ';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/Index.vue